<template>
  <v-dialog v-model="show" persistent width="500" v-if="show">
    <v-card>
      <v-card-title class="d-flex justify-space-between"
      ><div v-if="isTravelEvent">Create Travel Itinerary</div> <div v-else> Create event </div>
        <v-btn fab text small @click="$emit('close')" right
          ><v-icon>close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="12" v-if="!isTravelEvent">
            <div class="text-subtitle-1 font-weight-bold">Event type</div>
          </v-col>
          <v-col cols="12" md="12" v-if="!isTravelEvent">
            <v-select
              :items="multiConnectEventTypeItems"
              dense
              placeholder="Select your event type"
              outlined
              v-model="currentEvent.multiConnectEventType"
              :rules="requiredRules"
            />
          </v-col>
          <v-col cols="12" md="12">
            <div class="text-subtitle-1 font-weight-bold">
              Public/Private event
            </div>
          </v-col>
          <v-col cols="12" md="12">
            <v-select
              :items="linkPrivacyItems"
              dense
              outlined
              placeholder="Public/Private event"
              v-model="currentEvent.linkPrivacy"
              :rules="requiredRules"
              item-text="title"
              item-value="value"
              :menu-props="{ width: '100%' }"
            >
              <template v-slot:item="data">
                <div class="pa-2">
                  <div class="text-body" v-html="data.item.title"></div>
                  <div
                    class="grey--text text-caption"
                    v-html="data.item.description"
                  ></div>
                </div>
              </template>
            </v-select>
          </v-col>
          <v-col cols="6" md="6" v-if="!isTravelEvent">
            <v-switch
              label="Include sub-event(s)"
              v-model="currentEvent.hasSubEvents"
            ></v-switch>
          </v-col>
          <v-col cols="6" md="6" class="d-flex align-center" v-if="!isTravelEvent">
            <v-tooltip bottom max-width="300">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" class="ml-2" size="22">
                  mdi-help-circle-outline
                </v-icon>
              </template>
              <span>
                A sub-event is an event that falls under the umbrella of a
                larger event.
              </span>
            </v-tooltip>
          </v-col>
          <v-col cols="12" class="text-right">
            <v-btn
              width="200"
              depressed
              large
              class="primary"
              @click="handleNext"
            >
              Next
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import constants from "@/shared/constants";
import { mapGetters } from "vuex";

export default {
  props: {
    show: { type: Boolean, default: false },
    isSuperUserDashboard: { type: Boolean, default: false },
    isTravelEvent: { type: Boolean, default: false },
  },
  created() {
    this.multiConnectEventTypeItems = constants.MULTI_CONNECT_EVENT_TYPE;
  },
  computed: {
    ...mapGetters(["currentEvent"]),
  },
  data() {
    return {
      requiredRules: [(v) => !!v || "Value is required"],
      multiConnectEventTypeItems: [],
      linkPrivacyItems: [
        {
          id: 1,
          title: "Public event",
          description: "Attendees can share links to your event with anyone.",
          value: "Public",
        },
        {
          id: 1,
          title: "Private event",
          description:
            "Attendees can only join a link for an event upon receiving your invitation. <br/> As an Admin, you can share links with anyone at your discretion.",
          value: "Private",
        },
      ],
    };
  },
  methods: {
    handleNext() {
      //Only show event format page for events which don't have sub-events
      if (this.currentEvent.hasSubEvents) {
        if (this.currentEvent.linkPrivacy == "Public") {
          console.log("check");
          this.currentEvent.stepper =
            constants.MULTI_CONNECT_WIZARD_STEPPER_WITH_SUB_EVENTS_PUBLIC_EVENT;
          this.currentEvent.currentStep = constants.EVENT_FORMAT_PAGE;
        } else {
          this.currentEvent.stepper =
            constants.MULTI_CONNECT_WIZARD_STEPPER_WITH_SUB_EVENTS;
          this.currentEvent.currentStep = constants.EVENT_HOST_PAGE;
        }
      } else {
        this.currentEvent.stepper = constants.MULTI_CONNECT_WIZARD_STEPPER;
        this.currentEvent.currentStep = constants.EVENT_FORMAT_PAGE;
      }

      this.currentEvent.save();

      //Redirect to wizard
      if (this.isSuperUserDashboard) {
        this.$router.push({
          name: "addMultiConnect",
          params: { eventId: this.currentEvent.id },
          query: { privilege: "superUser" },
        });
      } else {
        this.$router.push({
          name: this.isTravelEvent ? "editMultiConnect" : "addMultiConnect",
          params: { eventId: this.currentEvent.id },
        });
      }
    },
  },
};
</script>

<style>
</style>